<template>
  <section>
    <div class="row">
      <div
        id="loadingmessage"
        style="
          text-align: center;
          margin: 0px;
          padding: 0px;
          position: fixed;
          right: 0px;
          top: 0px;
          width: 100%;
          height: 100%;
          background-color: white;
          z-index: 30001;
          opacity: 0.8;
        "
        v-if="loading"
      >
        <p style="position: absolute; color: White; top: 40%; left: 40%">
          <img src="../../../assets/snakes.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              DETAILS &nbsp;
              <!-- <router-link :to="'/sightingsloc1/'+this.id ">
                <span>
                  <i style="color:red!important" class="fa fa-map-marker"></i>
                </span>
              </router-link>-->
            </h4>
            <div class="row">
              <!-- <div class="col-2">
                <div class="row pl-3">
                  <output class="flex md12">
                    <enlargeable-image
                      v-if="im"
                      v-bind:src="image"
                      v-bind::src_large="image"
                    >
                      <img
                        :src="image"
                        v-if="im"
                        style="width: 100%; height: auto"
                      />
                    </enlargeable-image>
                
                  </output>
                </div>
              </div> -->

              <div class="col-md-7" v-if="data != ''">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <h5>Report Details</h5>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Description</th>
                      <td>{{ data.reportId.description }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake</th>
                      <td v-if="data.reportId.snake != undefined">
                        {{ data.reportId.snake.name }}
                      </td>
                      <td v-else>Not Known</td>
                    </tr>
                    <tr>
                      <th scope="col">Created At</th>
                      <td>{{ data.reportId.createdAt.slice(0, 10) }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Reported By</th>
                      <td>
                        {{ (data.reportId.user && data.reportId.user.name) || data.reportId.informername || "N/A" }} -
                        {{ (data.reportId.user && data.reportId.user.phone) || data.reportId.phone || "N/A" }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="col">Situation</th>
                      <td>{{ data.reportId.situation }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Division Name</th>
                      <td v-if="data.division[0]">{{ data.division[0].divisionName }}</td>
                    </tr>
                     <tr>
                      <th scope="col">Status</th>
                      <td><b>{{ data.status }}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-5" v-if="data.status == 'Approved'">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <h5>Approval Details</h5>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">                          <v-layout wrap justify-start>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescuer && data.rescuer.name"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescuer</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescuer.name }} -
                                  {{ data.rescuer.phone }}
                                  <span v-if="!data.rescuer.name">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="
                                data && data.rescue && data.rescue.rescuedAt
                              "
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescued At</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.rescuedAt.slice(0, 10) }}
                                  <span v-if="!data.rescue.rescuedAt">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.locality"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescued from</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.locality }}
                                  <span v-if="!data.rescue.locality">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Laid Eggs</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  <span v-if="data.rescue.laidEggs === true"
                                    >Yes</span
                                  >
                                  <span v-if="data.rescue.laidEggs === false"
                                    >No</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Gravid</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  <span v-if="data.rescue.gravid === true"
                                    >Yes</span
                                  >
                                  <span v-if="data.rescue.gravid === false"
                                    >No</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.district"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">District</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.district }}
                                  <span v-if="!data.rescue.district">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.quantity"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Quantity</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.quantity }}
                                  <span v-if="!data.rescue.quantity">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="data && data.rescue && data.rescue.sex"
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Sex</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.sex }}
                                  <span v-if="!data.rescue.sex">-</span>
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="
                                data && data.rescue && data.rescue.difficulties
                              "
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Rescue Difficulties</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.difficulties }}
                                  <span v-if="!data.rescue.difficulties"
                                    >-</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                            <v-flex
                              xs12
                              sm6
                              lg4
                              md6
                              pt-2
                              v-if="
                                data && data.rescue && data.rescue.delayReasons
                              "
                            >
                              <v-flex xs12 text-left>
                                <span class="itemKey">Delay Reasons</span>
                              </v-flex>
                              <v-flex xs12 text-left>
                                <span class="itemValue">
                                  {{ data.rescue.delayReasons }}
                                  <span v-if="!data.rescue.delayReasons"
                                    >-</span
                                  >
                                </span>
                              </v-flex>
                            </v-flex>
                          </v-layout></th>
                      <td v-if="data.approval.remarks != undefined">{{ data.approval.remarks }}</td>
                        <td v-else>Remarks not added</td>
                    </tr>
                  </tbody>
                </table>
              </div>

               <div class="col-md-5" v-if="data.status == 'Closed'">
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <h5>Details</h5>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Remarks</th>
                      <td>{{ data.approval.remarks }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="col-md-6"
                v-if="
                  data.status == 'Rescued' ||
                  data.status == 'Released' ||
                  data.status == 'Approved' ||
                  data.status == 'OnReview' ||
                  data.status == 'Closed'
                "
              >
                <br /><br />
                <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <th scope="col" style="min-width: 150px">
                        <h5>Rescue Details</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Rescued At</th>
                      <td>{{ data.rescue.rescuedAt.slice(0, 10) }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Rescuer</th>
                      <td v-if="data && data.rescuer && data.rescuer.name">{{data.rescuer.name}} - {{data.rescuer.phone}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Rescued from</th>
                      <td>{{ data.rescue.locality }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Laid Eggs</th>
                      <td>{{ data.rescue.laidEggs }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Gravid</th>
                      <td>{{ data.rescue.gravid }}</td>
                    </tr>
                    <tr>
                      <th scope="col">District</th>
                      <td>{{ data.rescue.district }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Quantity</th>
                      <td>{{ data.rescue.quantity }}</td>
                    </tr>
                    <!-- <tr>
                      <th scope="col">Sex</th>
                      <td>{{ data.rescue.sex }}</td>
                    </tr> -->
                    <tr>
                      <th scope="col">Rescue Difficulties</th>
                      <td>{{ data.rescue.difficulties }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Delay Reasons</th>
                      <td>{{ data.rescue.delayReasons }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="col-md-6"
                v-if="
                  (data.status == 'Released' ||
                  data.status == 'Approved' ||
                  data.status == 'OnReview') && data.release.type == 'Release'"
              >
                <br /><br />
               <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <th scope="col" style="min-width:150px;">
                        <h5>Released Details</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Released Date</th>
                      <td>{{data.release.releasedAt.slice(0,10)}}</td>
                    </tr>
                    <tr></tr>
                    <tr>
                      <th scope="col">Released or Not?</th>
                      <td>
                        <p v-if="data.release.releasedOrNot == 'false'">No</p>
                        <p v-else>Yes</p>
                      </td>
                    </tr>
                    <tr>
                      <th scope="col">Released from</th>
                      <td>{{data.release.locality}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake Health</th>
                      <td>{{data.release.snakeHealth}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake Mishaps</th>
                      <td v-if="data.release.mishaps==false">No Changes</td>
                      <td v-if="data.release.mishaps==true">Yes</td>
                    </tr>
                    <tr>
                      <th scope="col">District</th>
                      <td>{{data.release.district}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="col-md-6"
                v-if="
                  (data.status == 'Released' ||
                  data.status == 'Approved' ||
                  data.status == 'OnReview' ||
                  data.status == 'Closed') && data.release.type == 'Handover'"
              >
                <br /><br />
              <table class="table table-white flex md12">
                  <thead>
                    <tr>
                      <th scope="col" style="min-width:150px;">
                        <h5>Released Details</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="col">Released Date</th>
                      <td>{{data.release.releasedAt.slice(0,10)}}</td>
                    </tr>
                    <tr></tr>
                    <tr>
                      <th scope="col">Released or Not?</th>
                      <td>
                        <p v-if="data.release.releasedOrNot == 'false'">No</p>
                        <p v-else>Yes</p>
                      </td>
                    </tr>
                    <tr>
                      <th scope="col">Handovered to</th>
                      <td v-if="data.release.handoverplatform == 'Range'">{{data.release.handoverrange.rangeName}}</td>
                       <td v-if="data.release.handoverplatform == 'Division'"> {{data.release.handoverdivision.divisionName}}</td>
                       <td v-if="data.release.handoverplatform == 'RRT'">{{data.release.handoverrrt.name}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Snake Mishaps</th>
                      <td v-if="data.release.mishaps==false">No Changes</td>
                      <td v-if="data.release.mishaps==true">Yes</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <hr>
                 <div class="col-md-12" v-if="photographs.length > 0">
              <p><b>Reported Images</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in photographs" :src="src" :key="src">
    </div>
            </div>
     <div class="col-md-12" v-if="rescuedimages.length > 0">
              <p><b>Rescued Images</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in rescuedimages" :src="src" :key="src">
    </div>
              </div>
               <div class="col-md-12" v-if="releasedimages.length > 0">
              <p><b>Released Images</b></p>
              <div class="images" v-viewer="{movable: false}">
      <img style="
    vertical-align: middle;
    border-style: none;
    width: 10%;
    height: auto;
    padding-left: 10px;padding-bottom:10px;" v-for="src in releasedimages" :src="src" :key="src">
    </div>
              </div>
              <hr>
              <hr>
             <div class="col-md-12">
                <p><b>Map</b></p>
                <div id="map"></div>
              </div>
              
              <div class="col-md-12">
                <br><br>
              <div class="row">
             <div class="col-md-4">
                <button class="btn btn-danger" @click="deleteItem()">Delete Operation</button>
             </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import EnlargeableImage from "@diracleo/vue-enlargeable-image";
export default {
  components: {
    EnlargeableImage,
  },
  name: "myprofile",
  props: ["id"],
  data() {
    return {
      image: null,
      name: "",
      data: "",
      userdata: [],
      loading: false,
      im: "",
      idByAdmin: "",
      distance: "",
      remarks: "",
      rescuerCode: "",
      item: [],
      assignedTo: "",
       photographs: [],
       rescuedimages: [],
      releasedimages: []
    };
  },
  mounted: function () {
    this.getview();
  },

  methods: {
    getview() {
      this.loading = true;
      var mapCanvas = document.getElementById("map");
      var vm = this;
      axios({
        method: "GET",
        url: "https://sarpatnapi.leopardtechlabs.in/operation/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: { id: this.id },
      })
        .then((response) => {
          if (response.data && response.data.status === true) {
            this.data = response.data.data;
            this.$nextTick(() => {
              try {
                // 1. Process Images
                this.photographs = [];
                if (response.data.reportedimages) {
                  for (var j = 0; j < response.data.reportedimages.length; j++) {
                    this.photographs.push("https://sarpatnapi.leopardtechlabs.in/u/" + response.data.reportedimages[j]);
                  }
                }
                this.rescuedimages = [];
                if (response.data.rescuedimages) {
                  for (var k = 0; k < response.data.rescuedimages.length; k++) {
                    this.rescuedimages.push("https://sarpatnapi.leopardtechlabs.in/u/" + response.data.rescuedimages[k]);
                  }
                }
                this.releasedimages = [];
                if (response.data.releasedimages) {
                  for (var l = 0; l < response.data.releasedimages.length; l++) {
                    this.releasedimages.push("https://sarpatnapi.leopardtechlabs.in/u/" + response.data.releasedimages[l]);
                  }
                }

                if (vm.data.reportId) {
                  this.userdata = vm.data.user || [];
                  this.im = vm.data.reportId.pic;
                  if (vm.data.reportId.pic !== null) {
                    this.image = "https://sarpatnapi.leopardtechlabs.in/u/" + vm.data.reportId.pic;
                  }
                  if (vm.data.division && vm.data.division.length > 0) {
                    this.divisionid = vm.data.division[0]._id;
                    this.division = vm.data.division;
                  }

                  // 2. Map Plotting
                  if (mapCanvas) {
                    var markersToPlot = [];

                    // a. Reported Location
                    if (vm.data.reportId.location && vm.data.reportId.location.length > 1) {
                      var rLat = vm.data.reportId.location[1];
                      var rLng = vm.data.reportId.location[0];
                      if (rLat > 40 && rLng < 20) {
                        var tR = rLat; rLat = rLng; rLng = tR;
                      }
                      markersToPlot.push({
                        lat: rLat,
                        lng: rLng,
                        title: "Reported Location",
                        icon: "http://maps.google.com/mapfiles/kml/pal4/icon49.png"
                      });
                    }

                    // b. Rescued Location
                    if (vm.data.rescue && vm.data.rescue.location && vm.data.rescue.location.length > 1) {
                      var sLat = vm.data.rescue.location[1];
                      var sLng = vm.data.rescue.location[0];
                      if (sLat > 40 && sLng < 20) {
                        var tS = sLat; sLat = sLng; sLng = tS;
                      }
                      markersToPlot.push({
                        lat: sLat,
                        lng: sLng,
                        title: "Rescued Location",
                        icon: "http://maps.google.com/mapfiles/kml/pal4/icon48.png"
                      });
                    }

                    // c. Released Location
                    if (vm.data.release && vm.data.release.location && vm.data.release.location.length > 1) {
                      var lLat = vm.data.release.location[1];
                      var lLng = vm.data.release.location[0];
                      if (lLat > 40 && lLng < 20) {
                        var tL = lLat; lLat = lLng; lLng = tL;
                      }
                      markersToPlot.push({
                        lat: lLat,
                        lng: lLng,
                        title: "Released Location",
                        icon: "http://maps.google.com/mapfiles/kml/pal4/icon52.png"
                      });
                    }

                    if (markersToPlot.length > 0) {
                      var bounds = new google.maps.LatLngBounds();
                      var mapOptions = {
                        mapTypeId: google.maps.MapTypeId.HYBRID
                      };
                      vm.map = new google.maps.Map(mapCanvas, mapOptions);

                      markersToPlot.forEach((m) => {
                        var pos = new google.maps.LatLng(m.lat, m.lng);
                        bounds.extend(pos);

                        var markerInstance = new google.maps.Marker({
                          map: vm.map,
                          position: pos,
                          title: m.title,
                          icon: m.icon,
                        });

                        var infoText = "<strong>" + m.title + "</strong><br>Lat: " + m.lat.toFixed(6) + "<br>Lon: " + m.lng.toFixed(6);
                        var infowindow = new google.maps.InfoWindow({ content: infoText });

                        google.maps.event.addListener(markerInstance, "click", function () {
                          infowindow.open(vm.map, markerInstance);
                        });
                      });

                      if (markersToPlot.length > 1) {
                        vm.map.fitBounds(bounds);
                      } else {
                        vm.map.setCenter(bounds.getCenter());
                        vm.map.setZoom(14);
                      }
                    }
                  }
                }
              } catch (err) {
                console.error("Error initializing approved view details:", err);
              } finally {
                this.loading = false;
              }
            });
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          console.error("API error:", err);
          this.loading = false;
          alert("Error loading data!!");
        });
    },
          deleteItem: function (item) {
        if (confirm("Are you sure?")) {
      var vm = this;
      vm.item = this.id;
      axios({
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        url: "https://sarpatnapi.leopardtechlabs.in/operation/delete",
        data: {
          id: vm.item,
        },
      })
        .then((response) => {
          alert("Operation was successfully Deleted");
           this.$router.push("/approvedList/");
        })
        .catch((e) => {});
          }
    },
  },
};
</script>
<style>
.modal-footer {
  display: none !important;
}
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
#map {
  height: 350px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/forms/operation/approvedDetails.vue